import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import LifeMartStackInvite from "@/pages/LifeMartStackInvite";

// Kept live as of 2026-08-06 -- see src/config/featureFlags.ts
// LIFEMART_PUBLIC_PAGES_ENABLED doc comment.
export const Route = createFileRoute("/lifemart/stack-invite")({
  head: () => seoHead("/lifemart/stack-invite"),
  component: LifeMartStackInvite,
});
